import React from "react";
import useThemeColors from "../organization/portal/useThemeColors";
import useTranslation from "../../i18n/useTranslation";

function Footer() {
    const {t} = useTranslation();
    const colors = useThemeColors();
    const style = {
        // position: 'fixed',
        height: 60,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: colors.primary,
        color: colors.textOnPrimary,
    };

    return (
        <footer className="main-footer" style={style}>
            {t('home.footer.rights', {year: new Date().getFullYear()})} | {t('home.footer.angeonx')}
            <div className="float-right d-none d-sm-inline-block">
                <b>{t('home.footer.version')}</b> 1.44.0
            </div>
        </footer>
    );
}

export default Footer;